<template>
  <div v-if="poweredBy" class="branding" :style="{ backgroundColor: bgColor, color: fontColor }">
    <a class="link" v-if="poweredBy.hyperlink" :href="poweredBy.hyperlink">
      <span class="text" v-if="poweredBy.text">{{ poweredBy.text }}</span>
      <img class="image" height="20" v-if="poweredBy.image" :src="poweredBy.image" :alt="poweredBy.text">
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Branding',
  computed: {
    ...mapGetters({
      poweredBy: 'theme/poweredBy',
      theme: 'theme/theme',
    }),
    bgColor() {
      return undefined;
      // return this.theme?.content?.botBubbleColor;
    },
    fontColor() {
      return this.theme?.content?.botFontColor;
    },
  }
}
</script>

<style lang="scss" scoped>
.branding {
  display: flex;
  margin: 0;
  height: 30px;
  color: 666666;
}
.text {
  margin-right: .5em;
  word-break: keep-all;
  font-size: 12px;
}
.image {
  height: 14px;
}
.link {
  color: inherit;
  display: flex;
  width: 100%;
  align-items: center;
  text-decoration: none;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
